import SelectComponent from "@via/components/select/select";
import { requiredValidation } from "@via/utils/form-validators";

const fileNameOptions = [
  { label: "Row Header", value: "row" },
  { label: "Column Header", value: "column" },
  { label: "Filename", value: "filename" },
];
const featureOptions = [
  { label: "Row Header", value: "row" },
  { label: "Column Header", value: "column" },
  { label: "Both Headers", value: "both" },
];

export const MetadataTrackerConfiguration = ({
  control,
  errors,
  isDisabled,
}) => {
  return (
    <>
      <div className="my-6 flex flex-row items-center">
        <label className="flex w-64 flex-row items-center text-sm font-medium leading-6 text-gray-900">
          Location of the File Name
        </label>
        <div className="mt-2 w-full">
          <SelectComponent
            control={control}
            name="pubDmeta.filename"
            placeholder="Select Filename"
            options={fileNameOptions}
            enableClear={false}
            rules={requiredValidation("Filename")}
            readOnly={isDisabled}
          />
          {errors.pubDmeta?.filename && (
            <span className="text-xs text-rose-500">
              {errors.pubDmeta?.filename.message}
            </span>
          )}
        </div>
      </div>
      <div className="my-6 flex flex-row items-center">
        <label className="flex w-64 flex-row items-center text-sm font-medium leading-6 text-gray-900">
          Location of the Features
        </label>
        <div className="mt-2 w-full">
          <SelectComponent
            control={control}
            name="pubDmeta.feature"
            placeholder="Select Feature"
            options={featureOptions}
            enableClear={false}
            rules={requiredValidation("Feature")}
            readOnly={isDisabled}
          />
          {errors.pubDmeta?.feature && (
            <span className="text-xs text-rose-500">
              {errors.pubDmeta?.feature.message}
            </span>
          )}
        </div>
      </div>
    </>
  );
};
